import { NavLabels, SubNavLabels } from "@components/Layout";
import { IssueState } from "@store/issue/types";
import { Frequencies } from "@store/recurringIssues/types";
import { RoomStates } from "@store/space/types";
import { UserRoles } from "@store/user/types";

export default {
  common: {
    all: "Alle",
    notApplicable: "n.v.t.",
    cancel: "Annuleren",
    delete: "Verwijderen",
    submit: "Bevestigen",
    save: "Opslaan",
    saveChanges: "Wijzigingen opslaan",
    add: "Toevoegen",
    change: "Wijzigen",
    back: "Terug",
    filter: "Filter",
    logout: "Uitloggen",
    loading: "Aan het laden...",
    space: "Kamer",
    spaces: "Kamers",
    issue: "Taak",
    issues: "Taken",
    photos: "Foto's",
    area: "Sectie",
    areas: "Secties",
    property: "Locatie",
    roomType: "Kamertype",
    customSpace: "Aangepaste kamer",
    transactions: "Gegevens",
    room: "Ruimte",
    rooms: "Ruimtes",
    action: "Actie",
    date: "Datum",
    export: "Exporteer {{value}}",
    total: "Totaal",
    name: "Naam",
    giveName: "Voer een naam in",
    floor: "Verdieping",
    youSure: "Weet je het zeker?",
    unknown: "Onbekend",
    noData: "Geen data beschikbaar",
    tryAgain: "Probeer opnieuw",
    remark: "Opmerkingen",
    resetFilter: "Verwijder alle filters",
    general: "Algemeen",
    optional: "optioneel",
    view: "Bekijken",
    priority: "Prioriteit",
    tasks: "Periodieke taken",
    and: "en",
    selectDate: "Selecteer een datum",
    feedback: "Feedback",
  },
  counts: {
    room_one: "{{count}} Kamer",
    room_other: "{{count}} Kamers",
  },
  user: {
    sessionExpired: "Sessie verlopen, log opnieuw in.",
    self: "Gebruiker",
    role: "Rol",
    switch: "Wissel {{value}}",
  },
  layout: {
    refresh: "Vernieuwen",
    refreshMessage: 'Druk op "Vernieuwen" voor de meest actuele data.',
    fold: "Inklappen",
    menu: {
      [NavLabels.Dashboard]: "Dashboard",
      [NavLabels.Overview]: "Kamers",
      [NavLabels.AppLogin]: "Inloggen",
      [NavLabels.DayReports]: "Weekoverzicht",
      [NavLabels.TdOverview]: "Technische Dienst",
      [NavLabels.GsOverview]: "Algemene Dienst",
      [NavLabels.TeamSettings]: "Team beheren",
      [NavLabels.AreaSettings]: "Secties beheren",
      [NavLabels.CustomRoomSettings]: "Ruimtes beheren",
      [NavLabels.RecurringIssues]: "Periodieke taken",
      [NavLabels.DayReportSettings]: "Dagafsluiting beheren",
      [NavLabels.ActionsLog]: "Kameracties",
      [SubNavLabels.Settings]: "Instellingen",
      [SubNavLabels.None]: "Geen",
      [NavLabels.DayOverview]: "Dagoverzicht",
      [NavLabels.ExtraTasks]: "Extra taken",
      [NavLabels.TypeGroups]: "Tarieftypegroepen",
    },
  },
  dayreport: {
    week: "Week",
    editWarning: "Er zijn handmatig wijzigingen toegepast",
    send: {
      title: "Weet je het zeker dat je het weekoverzicht wilt versturen?",
      description: "Dit weekoverzicht wordt verstuurd naar:",
      button: "Ja, verstuur deze week",
      self: "Versturen",
      export: "Exporteer weekoverzicht",
    },
    manage: "Dagafsluiting beheren",
    endOfDay: "Dagafsluiting",
    weekOverview: "Weekoverzicht",
    expectedOccupancy: "Verwachte bezetting",
    extra: "Extra taken",
    deletedExtra:
      "Deze extra is verwijderd. Je kunt de waarde nog inzien, wijzigen kan niet meer.",
    addRemark: "Opmerking toevoegen",
    writeRemark: "Schrijf hier je opmerking",
    noRemarks: "Er zijn nog geen opmerkingen toegevoegd.",
    noChanges: "Er zijn geen wijzigingen gedaan.",
    dayView: "Dagoverzicht",
    saveAndApprove: "Opslaan & Akkoord",
    approve: "Akkoord",
    approval: "Goedkeuring",
    unsavedChanges: "De aangepaste cijfers zijn nog niet opgeslagen.",
    difference: "Schoonmaakverschil",
    popover: {
      green: "Green choice <strong>{{number}}</strong>",
      orange: "Orange choice <strong>{{number}}</strong>",
      nonGreenSkip: "Geen schoonmaak <strong>{{number}}</strong>",
      doNotDisturb: "Niet storen <strong>{{number}}</strong>",
    },
    sold: {
      title: "Verkocht",
      description:
        "het aantal kamers dat voor die nacht verkocht was, inclusief no-shows. De no-shows worden hiervan afgetrokken om tot ‘Schoon te maken’ te komen. De cijfers werken bij na een wijziging in het PMS, zolang de dagafsluiting nog niet is geaccordeerd.",
    },
    carriedOverFromYesterday: {
      title: "Doorgezet (van gisteren)",
      description:
        "alle kamers die vanuit gisteren nog niet schoongemaakt zijn.",
    },
    dayuse: {
      title: "Daggebruik",
      description:
        "alle kamers die we vanuit het PMS doorkrijgen als daggebruik. De cijfers werken bij na een wijziging in het PMS, zolang de dagafsluiting nog niet is geaccordeerd.",
    },
    carriedOver: {
      title: "Doorschuiven (vandaag)",
      description:
        "kamers die nog vuil zijn maar gisteren (en dus niet vandaag) al vertrokken zijn.",
    },
    totalDescription:
      "de verkochte kamers, het daggebruik en de van gisteren doorgezette kamers opgeteld.",
    green: {
      title: "Green choice",
      description:
        "kamers waarbij de gast (via de mail) of receptie (via ServiceV4) heeft aangegeven dat er geen schoonmaak nodig is (green choice).",
    },
    orange: {
      title: "Orange choice",
      description:
        "kamers waarbij de gast (via de mail) of receptie (via ServiceV4) heeft aangegeven dat er enkel handdoeken of tasje (orange choice) benodigd is + de kamers die via de HKTD app op ‘tasje opgehangen’ zijn gezet.",
    },
    nonGreenSkip: {
      title: "Geen schoonmaak",
      description:
        "kamers waarbij de gast zonder green choice ervoor heeft gekozen de schoonmaak over te slaan.",
    },
    doNotDisturb: {
      title: "Niet storen",
      description: "de kamers die via de HKTD app op ‘niet storen’ zijn gezet.",
    },
    cleaned: {
      title: "Schoon te maken",
      description:
        "de verkochte kamers, het daggebruik en de van gisteren doorgezette kamers opgeteld, min de no-shows en de kamers die vandaag doorschuiven. Daarna gaan de uitzonderingen eraf: green choice, orange choice, geen schoonmaak en niet storen.",
    },
    totalCleaned: {
      title: "Totaal schoongemaakt",
      description:
        "dit zijn de kamers die via de HKTD app op schoon zijn gezet.",
    },
    note: {
      title: "Let op",
      description:
        "bepaalde cijfers kunnen handmatig aangepast worden door de HKS of FOM, de aangepaste cijfers worden dan meegenomen in de berekening.",
    },
    calculate: "Hoe wordt dit berekend",
    noData:
      "Nog geen gegevens beschikbaar. Deze gegevens worden op een later moment opgehaald.",
    noShow: "No-show",
    clean: "Schoongemaakt",
    exceptions: "Uitzonderingen",
    oldValue: "Oude waarde",
    new_Value: "Nieuwe waarde",
    whoMay: {
      send: "Wie mag het weekoverzicht versturen?",
      edit: "Wie mag cijfers aanpassen?",
      create: "Wie mag extra uren schrijven?",
      receive: "Naar welke e-mailadressen wordt het weekoverzicht verstuurd?",
    },
    setupEmail: "E-mailadressen instellen",
    enableEmail:
      "Om optimaal gebruik te kunnen maken van het weekoverzicht (en de dagafsluiting) moet deze module worden aangezet.",
    noEmail:
      "Er is geen e-mail toegevoegd, het weekoverzicht kan niet verstuurd worden.",
    rateTypeGroup: "Tarieftypegroepen wijzigen",
    editRateType: "Klik hier om de groepen te wijzigen of in te zien",
    settings: {
      reportPermission: {
        fom: "Front office",
        hk: "Housekeeping Supervisor",
        gs: "Algemene Dienst Supervisor",
        fomHk: "Front office & Housekeeping Supervisor",
        fomGs: "Front office & Algemene Dienst Supervisor",
        hkGs: "Housekeeping & Algemene Dienst Supervisor",
        fomHkGs: "Front office, Housekeeping & Algemene Dienst Supervisor",
      },
    },
  },
  rateType: {
    create: "Nieuwe tarieftypegroep",
    update: "Wijzig tarieftypegroep",
    delete: "Verwijder groep",
    groupName: "Groepsnaam",
    groupDescription: "Voer een groepsnaam in",
    defaultGroup:
      "Het is niet mogelijk om deze groep te verwijderen. Je kunt de kamertypes wel onder een andere groep indelen",
    roomType: "Kamertypes",
    belongsTo: "Behoort tot groep",
    deleteDescription:
      "De verwijderde kamertypes worden teruggezet onder de groep 'Kamers' of 'Suites'.",
    deleteConfirmation:
      "Je staat op het punt om de groep {{name}} te verwijderen. \n Deze actie kan niet ongedaan gemaakt worden.",
    groups: "Tarieftypegroepen",
    group: "Groep",
    groupedRatesInfo: "Aanpassingen gaan pas in vanaf volgende week maandag.",
    countTypes: "Aantal toegevoegde kamertypes",
  },
  hkStatistics: {
    tableContent: {
      arrivals: "Aankomsten",
      atStart: "Begin",
      carriedOver: "Doorgezet",
      carriedOverFromYesterday: "Gisteren doorgezet",
      currently: "Huidig",
      departures: "Vertrekkers",
      dirtyVacant: "Alle vrij/vuile kamers",
      notAvailable: "Statistieken zijn (nog) niet beschikbaar",
      roomsCleaned: "Kamers schoongemaakt",
      stayovers: "Blijvers",
      rateTypesCleaned: "Suites schoongemaakt",
    },
    emptyMessage: "De statistieken konden helaas niet worden opgehaald.",
    atStart: "Begin",
    currently: "Huidig",
  },
  forecast: {
    occupiedLeft: "Bezet (links)",
    availableRight: "Beschikbaar (rechts)",
    expectedArrivals: "Verwachte aankomsten alle type kamers",
    expectedDepartures: "Verwachte vertrekkers",
    expectedStayovers: "Verwachte blijvers",
    totalToClean: "Totaal schoon te maken (blijver + vertrek)",
    totalRoomsLeft: "Totaal kamers (links)",
    totalGuestsRight: "Totaal gasten (rechts)",
    rooms: "Overige kamers totaal",
    suites: "Luxe kamers totaal",
    lastSync: "Laatste synchronisatie",
  },
  pmsNotification: {
    content: {
      bad: "De kamerstatussen zijn niet up-to-date door een connectieprobleem met het PMS.",
      poor: "De kamerstatussen zijn mogelijk niet up-to-date door een connectieprobleem met het PMS.",
    },
    heading: {
      bad: "PMS langere tijd niet bereikbaar",
      poor: "PMS niet bereikbaar",
    },
  },
  actions: {
    export: {
      failed: "{{value}} kon niet geëxporteerd worden.",
    },
    assign: {
      failed: "{{value}} is niet toegewezen.",
      success: "{{value}} is succesvol toegewezen.",
    },
    unassign: {
      failed: "{{value}} niet toewijzen is mislukt.",
      success: "{{value}} zijn niet meer toegewezen.",
      success_plural: "{{value}} is niet meer toegewezen.",
    },
    cleaning: {
      start: {
        failed: "Beginnen met schoonmaken niet gelukt",
        success: "Kamer wordt schoongemaakt",
      },
      stop: {
        failed: "Stoppen met schoonmaken is niet gelukt",
        success: "Schoonmaak is gestopt",
      },
      finish: {
        failed: "Kan kamer niet op schoon zetten",
        success: "Kamer is succesvol schoongemaakt",
      },
    },
    inspectionFinish: {
      failed: "Kamer inspecteren is mislukt",
      success: "Kamer is succesvol geïnspecteerd",
    },
    issueUpdate: {
      failed: "Taakstatus updaten is mislukt",
      success: "Status van de taak is geüpdatet",
    },
    add: {
      failed: "{{value}} niet toegevoegd.",
      userFailed:
        "Let op: het is niet mogelijk om hetzelfde e-mailadres voor meerdere gebruikers / hotels te gebruiken.",
      success: "{{value}} is succesvol toegevoegd",
      success_plural: "{{value}} is succesvol toegevoegd",
    },
    update: {
      failed: "{{value}} niet geüpdatet.",
      success: "{{value}} is succesvol geüpdatet",
      success_plural: "{{value}} zijn succesvol geüpdatet",
    },
    delete: {
      failed: "{{value}} niet verwijderd.",
      success: "{{value}} is succesvol verwijderd",
      success_plural: "{{value}} zijn succesvol verwijderd",
    },
    approved: {
      failed: "{{value}} kon niet goedgekeurd worden.",
      success: "{{}} is goedgekeurd.",
    },
    send: {
      failed: "{{value}} kon niet verzonden worden.",
      success: "{{value} is succesvol verstuurd.",
    },
    refresh: {
      failed: "{{value}} kon niet vernieuwd worden.",
      success: "{{value}} gegevens vernieuwd.",
    },
    switch: {
      failed: "{{value}} niet gewisseld.",
      languageFailed: "Kon notificatie taal niet wisselen.",
      success: "{{value}} gewisseld.",
    },
    qrCode: {
      failed: "Het exporteren van de QR-codes is mislukt.",
      success: "De QR-codes zijn succesvol gedownload.",
    },
    default: {
      failed: "Mislukt.",
      success: "{{value}} is succesvol geüpdatet",
    },
    fetch: {
      failed:
        "De informatie kan momenteel niet opgehaald worden.\n  Controleer je internet en probeer het opnieuw.\n\n Mocht het probleem aanhouden, probeer dan opnieuw in te loggen.",
    },
  },
  hk: {
    insights: "Inzichten",
    roomState: {
      [RoomStates.OUT_OF_INVENTORY]: "Uit voorraad",
      [RoomStates.OUT_OF_ORDER]: "Buiten gebruik",
      [RoomStates.OUT_OF_SERVICE]: "Buiten dienst",
      cleanTowels: "handdoeken opgehangen",
      dirtyTowels: "handdoeken ophangen",
      dirtyAndInspected: "vuil & geïnspecteerd",
      cleanAndInspected: "schoon & geïnspecteerd",
      clean: "schoon",
      dirty: "vuil",
      extra: {
        vacantToday: "sinds vandaag vrij",
        leaving: "vertrekker",
        occupiedToday: "bezet sinds vandaag",
        staying: "blijver | {{current}}/{{total}}",
        vacant_zero: "vrij sinds vandaag",
        vacant_one: "vrij | {{count}} dag",
        vacant_other: "vrij | {{count}} dagen",
        dirtySince_one: "{{count}} dag",
        dirtySince_other: "{{count}} dagen",
        orange: "orange choice",
        skipCleaning: "geen schoonmaak (green choice)",
        doNotDisturb: "niet storen",
      },
    },
    loading: "Taak- en kamerstatussen aan het verwerken...",
    description: "Beschrijving: {{description}}",
    leavers: "Vertrekkers",
    stayers: "Blijvers",
    amountExtra: "Extra's ({{amount}})",
    filters: {
      skipCleaning: "Geen schoonmaak (green choice)",
      roomState: "Kamerstatus (+extra's)",
      guests: "Gasten",
      arrivals: "Aankomsten (+ extras)",
      cleaningState: "Schoonmaak status",
      tasks: "Taken",
      user: "Pers.",
      roomsWithExtra: "Kamers met extra's",
      roomsWithTasks: "Kamers met taken",
      occupiedToday: "Bezet sinds vandaag",
      rooms: {
        dirty: "Vandaag nog schoonmaken",
        clean: "Schone kamers",
      },
      legionella: "Legionella",
      dirty2Days: "Vuil 2+ dagen",
    },
    selectedRooms: "Geselecteerde kamers: {{count}}",
    assignRoom: "Kamers toewijzen",
    showQrCode: "Zet je muis in dit vlak voor de QR-code",
  },
  search: {
    title: "Zoeken",
    rooms: "Zoek een kamer",
    location: "Zoek een ruimte",
    noResults: "Geen {{object}} gevonden.",
    name: "Zoek op naam",
    employee: "Zoek een medewerker",
    task: "Zoek een taak",
    role: "Selecteer een rol",
    function: "Selecteer een functie",
    taskPersonRoom: "Zoek een taak, persoon of ruimte",
    taskRoom: "Zoek een taak of ruimte",
    roomOrHouseKeeper: "Zoek op kamer of housekeeper",
    notFound:
      "Er zijn helaas geen {{search}} gevonden voor de huidige zoekopdracht en/of filters.",
    rateType: "Zoek een kamertype",
  },
  tasks: {
    delete: {
      title: "Periodieke taak verwijderen",
      description:
        "Je staat op het punt om de periodieke taak '{{value}}' te verwijderen.",
      result: "De taak '{{label}}' is nu verwijderd.",
    },
    create: {
      result: "De taak '{{label}}' is aangemaakt.",
      success: "Nieuwe periodieke taak aangemaakt",
      failed: "De periodieke taak is niet aangemaakt.",
    },
    update: {
      result: "De taak '{{label}}' is aangepast.",
      success: "Periodieke taak aangepast",
      failed: "De periodieke taak is niet aangepast.",
    },
    number: "Taak {{task}}",
    add: "+ voeg nog een taak toe",
    assign: "Wijs toe",
    assignTask: "Wijs taak toe",
    assignTasks: "Taken toewijzen",
    unassignTasks: "Taken verwijderen",
    unassignUser: "Medewerkers verwijderen",
    empty: "Er zijn nog geen periodieke taken aangemaakt.",
    labelPlaceholder: "Schoonmaken",
    remove: "Verwijder taak",

    // Periodic tasks
    months: "Maand",
    type: "Taaksoort",
    all: "Alle taken",
    housekeeping: "Housekeeping",
    technical: "Technische Dienst",
    general: "Algemene Dienst",
    addNew: "Nieuwe periodieke taak aanmaken",
    change: "Periodieke taak bewerken",
    responsibility: "Verantwoordelijke",
    startDate: "Startdatum",
    endDate: "Einddatum",
    onNextOccurrence: "De eerstvolgende herhaling is op {{date}}",
    onFrequency: "Herhaling",
    onInterval: "Interval",
    setEndDate: "Einddatum instellen",
    pastDate: "Taak is verlopen ({{date}})",

    // Table columns
    nextOccurrence: "Eerstvolgend moment",
    name: "Taaknaam",
    locations: "Locatie(s)",
    frequency: "Ingepland",
    actions: "Meer",
  },
  actionLog: {
    actions: {
      space: {
        clean: {
          start: "schoonmaak gestart",
          stop: "schoonmaak gestopt",
          finish: "schoonmaak afgerond",
          skip: "schoonmaak overgeslagen",
        },
        assign: {
          add: "kamer toegewezen",
          remove: "kamer verwijderd",
        },
        inspect: {
          finish: "inspectie afgerond",
          approved: "inspectie afgerond & goedgekeurd",
          rejected: "inspectie afgerond & afgekeurd",
        },
      },
      issue: {
        work: {
          start: "taak gestart",
          stop: "taak gestopt",
          finish: "taak opgelost",
          wait: "taak in bestelling",
        },
        report: {
          create: "nieuwe taak aangemeld",
          attach: "bijlage toegevoegd",
        },
        assign: {
          add: "taak toegewezen aan service medewerker",
          remove: "taak verwijderd van service medewerker",
        },
      },
    },
  },
  area: {
    name: "Sectienaam",
    numberOfRooms: "Aantal kamers",
    assignedRooms: "Toegewezen kamers",
    noRoomsAssigned: "Nog geen kamers toegewezen",
    emptyMessage:
      "Er zijn nog geen secties aangemaakt. Druk op de knop hierboven om een sectie aan te maken.",
    delete: {
      action: "Verwijderen uit de sectie",
      description:
        "Je staat op het punt om toegewezen kamers uit een sectie te verwijderen.\nDeze actie kan niet ongedaan gemaakt worden.",
      area: "Je staat op het punt om de sectie '{{item}}' te verwijderen. \nDeze actie kan niet ongedaan gemaakt worden.",
    },
    assignSection_zero: "Toewijzen aan sectie",
    assignSection: "Toewijzen aan sectie ({{count}})",
    toAssign: "Wijs een sectie toe",
    select: "Selecteer een sectie",
    count: "Aantal kamers: {{count}}",
    remove: "Sectie verwijderen",
    update: "Sectie wijzigen",
    add: "Sectie toevoegen",
    charLeft_other: "{{count}} karakters over",
    charLeft_one: "{{count}} karakter over",
    charLeft_zero: "Geen karakters over",
  },
  customroom: {
    create: {
      title: "Openbare ruimte aanmaken",
      submit: "Ruimte aanmaken",
      add: "Ruimte toevoegen",
      nameRequired: "De openbare ruimte moet een naam hebben",
      groupRequired: "Groepsnaam is verplicht",
      nameInUse: "Deze naam is al in gebruik.",
    },
    changeTitle: "Kamer aanpassen",
    floor: "Verdieping {{floor}}",
    floorPlaceholder: "Bijv. 0 voor de begane grond, -1 voor de kelder",
    floorInvalid:
      "De verdieping moet een heel getal zijn, bijvoorbeeld 2, 0 of -1.",
    tooltip: "Tip: een korte titel werkt het beste.",
  },
  extra: {
    self: "Extra's",
    description: "Beschrijving van extra",
    hourAndTask: "Extra taken & uren",
    newTask: "Nieuwe extra",
    typeName: "Type naam",
    noExtra: "Er zijn nog geen extra's aangemaakt.",
    newTaskAction: "Klik hier om de taken te wijzigen of in te zien",
  },
  login: {
    self: "E-mailadres",
    password: "Wachtwoord",
    alreadyadded: "Het e-mailadres {{email}} is al toegevoegd.",
    invalid: "Het e-mailadres {{email}} is ongeldig.",
    enterNew: "Voer een e-mailadres in",
    loginError: "Verkeerd e-mailadres of wachtwoord",
    forgotPassword: "Wachtwoord vergeten?",
  },
  appLogin: {
    qrCodeInfo:
      "<strong>Inloggen via QR-code</strong> \n Housekeeping kan inloggen met een QR-code. Andere rollen (zoals TD of front-office) gebruiken de HKTD-app met gebruikersnaam en wachtwoord. \nBij vragen neem contact op met <0>hotelsupport@valkdigital.nl</0>",
  },
  issue: {
    typeTaskName: "Voer een taaknaam in",
    typeReporterName: "Voer een naam in",
    createdBy: "Aangemaakt door",
    reportedBy: "Geconstateerd door",
    createdAt: "Aangemaakt op",
    addRemark: "Voer een opmerking voor de taak in",
    priority: "Deze taak heeft prioriteit",
    change: "Wijzig taak",
    create: "Taak aanmaken",
    addNewTask: "Nieuwe taak aanmaken",
    newTask: "Nieuwe taak",
    states: {
      title: "Statussen",
      [IssueState.OPEN]: "Open",
      [IssueState.IN_PROGRESS]: "Actief",
      [IssueState.ON_HOLD]: "Inactief",
      [IssueState.ORDERED]: "In bestelling",
      [IssueState.DONE]: "Voltooid",
      all: "Alle",
    },
    createDate: "Aanmaakdatum",
    completedDate: "Datum voltooid",
    taskName: "Taaknaam",
    status: "Status",
    assignee: "Toegewezen",
    changeLog: "Wijzigingslog",
    changeDetails: "Details wijzigen",
    delete: {
      title: "Taak verwijderen",
      action: "Verwijder taak",
      description: "Je staat op het punt om de taak {{label}} te verwijderen.",
    },
    inactive: {
      title: "Inactief stellen",
      action: "Waarom moet deze taak inactief gesteld worden?",
      placeholder: "Voer hier een reden in",
      label: "Reden",
    },
    edit: "Taak wijzigen",
    view: "Taak detail",
    addImage: "Foto toevoegen",
    addAttachment: "Bijlage toevoegen",
    videoAttachment: "Videobijlage",
    noPreviewAvailable: "Geen voorbeeld beschikbaar",
    noAttachment: "Nog geen bijlagen",
    export: "Exporteer takenlijst",
    newIssueModal: {
      createdIssuesTitle: "Andere taken op deze locatie",
      columns: {
        date: "Datum",
        task: "Taak",
        status: "Status",
      },
    },
  },
  segment: {
    Groepen: "Groepen",
    ["Alle kamertypes"]: "Alle kamertypes",
    all: "Alle",
  },
  team: {
    addMember: "Teamlid toevoegen",
    detail: "Details",
    removeMember: "Teamlid verwijderen",
    inputName: "Naam van het teamlid",
    inputEmail: "E-mailadres van het teamlid",
    inputPassword: "Je eigen wachtwoord",
    inputPasswordInfo:
      "Vul hier je wachtwoord in om het e-mailadres te wijzigen.",
    inputEmailInfo:
      "Bij het aanmaken van een nieuw account wordt er een mail verstuurd naar het ingevuld e-mailadres",
    deleteConfirmation:
      "Je staat op het punt om {{value}} te verwijderen. \nDeze actie kan niet ongedaan gemaakt worden.",
  },
  roleNames: {
    [UserRoles.ADMIN]: "Admin",
    [UserRoles.HOTEL_MANAGER]: "Front office",
    [UserRoles.HK_MANAGER]: "Supervisor",
    [UserRoles.HK_MEMBER]: "Housekeeper",
    [UserRoles.TD_MANAGER]: "TD manager",
    [UserRoles.TD_MEMBER]: "TD medewerker",
    [UserRoles.TD_CREATOR]: "TD beheerder",
    [UserRoles.GS_MANAGER]: "AD manager",
    [UserRoles.GS_MEMBER]: "AD medewerker",
    [UserRoles.NONE]: "Geen",
  },
  months: {
    jan: "Januari",
    feb: "Februari",
    mar: "Maart",
    apr: "April",
    may: "Mei",
    jun: "Juni",
    jul: "Juli",
    aug: "Augustus",
    sep: "September",
    oct: "Oktober",
    nov: "November",
    dec: "December",
    all: "Alle maanden",
  },

  frequencyTypes: {
    [Frequencies.Daily]: "Dagelijks",
    [Frequencies.Weekly]: "Wekelijks",
    [Frequencies.Monthly]: "Maandelijks",
    [Frequencies.Yearly]: "Jaarlijks",
  },
  frequencies: {
    daily_one: "Elke dag",
    daily_other: "Elke {{count}} dagen",
    weekly_one: "Elke week op een {{date}}",
    weekly_other: "Elke {{count}} weken op een {{date}}",
    monthly_one: "Elke maand op de {{date}}",
    monthly_other: "Elke {{count}} maanden op de {{date}}",
    yearly_one: "Elk jaar op {{date}}",
    yearly_other: "Elke {{count}} jaar op {{date}}",
    manual: "Handmatig",
  },
  weekdays: {
    mon: "maandag",
    tue: "dinsdag",
    wed: "woensdag",
    thu: "donderdag",
    fri: "vrijdag",
    sat: "zaterdag",
    sun: "zondag",
  },
};
